// extracted by mini-css-extract-plugin
export var container = "_6p-1";
export var cornerButtonContainer = "_6p-5";
export var disabled = "_6p-2";
export var fileContainer = "_6p-4";
export var hiddenInput = "_6p-3";
export var widthContainer = "_6p-0";